import { render, staticRenderFns } from "./RegistrosApi.vue?vue&type=template&id=06d88fce&scoped=true&"
import script from "./registrosApi.js?vue&type=script&lang=js&"
export * from "./registrosApi.js?vue&type=script&lang=js&"
import style0 from "./RegistrosApi.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RegistrosApi.vue?vue&type=style&index=1&id=06d88fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d88fce",
  null
  
)

export default component.exports